module.exports = __webpack_public_path__ + "static/media/instruction_2.7bd20f25.svg";